<template>
<v-content class="spinelab-website-front">
  <v-container v-if="initiated">
    <v-flex xs12 sm12 md12>
      <h1 class="text-sm-left">ユーザ管理</h1>
    </v-flex>
    <template v-if="detail">
      <v-dialog v-model="dialog" max-width="500px">
        <v-card class="spinelab-website-front">
          <v-flex md10 offset-md1>
            <v-card-text>
              削除したユーザを元に戻すことはできません。本当に削除しますか。
            </v-card-text>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancelDialogue()">
              キャンセル
            </v-btn>
            <v-btn @click="confirmRemove()"
                   :loading="removing"
                   color="error">
              削除する
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        @click="backToList()"
        :loading="saving">
        一覧に戻る
      </v-btn>
      <v-layout v-for="column in editedItem"
                :key="column.label"
                row>
        <v-flex md3>
          <v-subheader>
            <p>{{column.label}}</p>
          </v-subheader>
        </v-flex>
        <v-flex md9 v-if="!column.editable">
          {{column.content}}
        </v-flex>
        <v-flex md9 v-else-if="column.editor === 'input-text'">
          <v-text-field
             v-model="column.content"
             :errorMessages="errorMessages[column.label] ?
 errorMessages[column.label].message : []">
          </v-text-field>
        </v-flex>
        <v-flex md9 v-else-if="column.editor === 'select-option'">
          <v-select
            :items="column.options"
            v-model="column.content"
            :errorMessages="errorMessages[column.label] ?
            errorMessages[column.label].message : []"
            single-line>
          </v-select>
        </v-flex>
      </v-layout>
      <v-btn
        color="error"
        v-if="editedId !== undefined"
        @click="remove()"
        :loading="saving">
        このユーザを削除する
      </v-btn>
      <v-btn
        color="success"
        @click="save()"
        :loading="saving">
        保存
      </v-btn>
    </template>
    <template v-else>
      <v-layout row>
        <v-flex xs3 sm3 md3 lg3 xl3>
          <v-btn color="primary" @click="showDetail()">
            新規ユーザ登録
          </v-btn>
        </v-flex>
        <v-flex xs1 sm1 md1 lg1 xl1></v-flex>
        <v-flex xs3 sm3 md3 lg3 xl3>
          <v-btn color="success"
                 @click="download"
                 :loading="downloading">
            CSVダウンロード
          </v-btn>
        </v-flex>
        <v-flex xs3 sm3 md3 lg3 xl3>
          <v-btn color="blue-grey"
                 @click="upload"
                 class="white--text"
                 :loading="uploading">
            CSVアップロード
          </v-btn>
          <form id="csv-upload-form">
            <input
              type="file"
              id="csv-upload"
              @change="csvupload($event.target.files)"
              accept="text/csv"
              style="display:none">
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="csvErrors" class="red lighten-3">
        <h3>
          CSVエラー
          <v-btn @click="deleteCsvErrors()">閉じる</v-btn>
        </h3>
        <v-flex xs12 v-for="error in csvErrors" :key="error">
          {{error}}
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs2 v-if="getRole() === 'superuser'">
          <v-select
            label="アドミンユーザ"
            :items="owners"
            item-text="name"
            item-value="id"
            v-model="searchOwnerId"
            single-line>
          </v-select>
        </v-flex>
        <v-spacer v-if="getRole() === 'superuser'" />
        <v-flex xs6>
          <v-text-field
            append-icon="search"
            label="検索"
            single-line
            :loading="loading"
            :disabled="loading"
            @keypress.enter="loadUsers"
            v-model="search">
          </v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-btn color="primary"
                 @click="loadUsers"
                 :disabled="loading">
            検索
          </v-btn>
        </v-flex>
        <v-spacer/>
        <v-btn icon @click="loadUsers" :disabled="loading">
          <v-progress-circular :size="20" indeterminate v-if="loading">
          </v-progress-circular>
          <v-icon v-else>cached</v-icon>
        </v-btn>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-data-table
            :headers="headers"
            :items="users"
            :total-items="totalItems"
            :pagination.sync="pagination"
            :loading="loading"
            rows-per-page-text="一度に表示するユーザ数"
            :rows-per-page-items="rowsPerPageItems"
            id="admin-users-data-table"
            >
            <template slot="headers" slot-scope="props">
              <th v-for="header in headers"
                  :key="header.value"
                  :style="`text-align: ${header.align || 'left'};`"
                  v-if="header.text !== 'アドミンユーザ' ||
                  (header.text == 'アドミンユーザ' && getRole() === 'superuser')"
              >
                {{header.text}}
              </th>
            </template>
            <template slot="items" slot-scope="props">
              <td v-for="header in headers" :key="header.value">
                <a @click="simulateUser(props.item)" v-if="header.value === 'simulation'">
                  このユーザとしてログイン
                </a>
                <a @click="showDetail(props.item)" v-else-if="header.value === 'detail'">
                  詳細
                </a>
                <a @click="showContacts(props.item)" v-else-if="header.value === 'contacts'">
                  お問合せ一覧
                </a>
                <template v-else-if="header.text !== 'アドミンユーザ'">
                  {{props.item[header.value]}}
                </template>
                <template v-else-if="header.text == 'アドミンユーザ' && getRole() === 'superuser'">
                  {{props.item[header.value]}}
                </template>
              </td>
            </template>
            <template slot="pageText" slot-scope="props">
              {{ props.itemsLength }}件中{{ props.pageStart }} - {{ props.pageStop }}件
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</v-content>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import { convert } from 'encoding-japanese';

const successUpdate = 'ユーザ情報の変更を保存しました';
const successCreate = '新規ユーザを登録しました';
const successRemove = 'ユーザを削除しました';
const failUpdate = '変更された情報の保存時にエラーが発生しました';
const failCreate = 'ユーザ登録時にエラーが発生しました';
const noSite = 'このユーザはホームページを持っていません';
const successCsvUpload = '更新しました';

export default {
  name: 'User',
  data() {
    return {
      loading: false,
      uploading: false,
      downloading: false,
      saving: false,
      initiated: false,
      users: [],
      totalItems: 0,
      detail: false,
      editedItem: [],
      editedId: undefined,
      search: '',
      owners: [],
      searchOwnerId: 'all',
      errorMessages: {},
      dialog: false,
      removing: false,
      csvErrors: undefined,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Login ID', value: 'login_id' },
        { text: '企業名', value: 'name' },
        { text: '公開ステータス', value: 'status' },
        { text: 'URL', value: 'new_url' },
        { text: 'アドミンユーザ', value: 'owner_name' },
        { text: '支店名等', value: 'bank_branch_name' },
        { text: '', value: 'contacts', sortable: false },
        { text: '', value: 'detail', sortable: false },
        { text: '', value: 'simulation', sortable: false },
      ],
      rowsPerPageItems: [50, 100, 1000],
      pagination: {},
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
    }),
    formTitle() {
      return this.editedItem.length === 0 ? '新規ユーザ登録' : 'ユーザ情報編集';
    },
    castPagination() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      return {
        order: sortBy || 'id',
        isDesc: descending || false,
        page: page || 1,
        perPage: rowsPerPage || this.rowsPerPageItems[0],
      };
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.loadUsers();
      },
    },
  },
  methods: {
    ...mapActions(['showAlert', 'setSite']),
    ...mapGetters(['getRole']),
    backToList() {
      this.errorMessages = [];
      this.detail = false;
    },
    async remove() {
      this.errorMessages = [];
      this.removing = false;
      this.dialog = true;
    },
    async cancelDialogue() {
      this.dialog = false;
    },
    async confirmRemove() {
      this.removing = true;
      const result = await this.requests.deleteUser(this.editedId);
      if (!result) {
        this.showAlert({ message: undefined, type: 'error' });
      } else {
        this.showAlert({ message: successRemove, type: 'success' });
      }
      this.dialog = false;
      this.detail = false;
    },
    async save() {
      this.saving = true;
      this.errorMessages = [];
      const result = await this.requests.postUserDetail(
        this.editedId, { user_informations: this.editedItem });
      if (result === undefined) {
        this.showAlert({ message: undefined, type: 'error' });
      } else if (result.isError) {
        this.errorMessages = result.data;
        this.showAlert({
          message: this.editedId === undefined ? failCreate : failUpdate,
          type: 'error',
        });
        this.saving = false;
        return;
      } else {
        this.showAlert({
          message: this.editedId === undefined ? successCreate : successUpdate,
          type: 'success',
        });
      }
      this.saving = false;
      this.detail = false;
    },
    async download() {
      this.downloading = true;
      const csv = await this.requests.exportUserCSV(
        this.castPagination, this.search, this.searchOwnerId);
      const sjisCSV = new Uint8Array(convert(csv, {
        to: 'SJIS',
        from: 'AUTO',
        type: 'array',
      }));
      const blob = new Blob([sjisCSV], { type: 'text/csv' });
      saveAs(blob, 'users.csv');
      this.downloading = false;
    },
    async upload() {
      document.getElementById('csv-upload').click();
    },
    async csvupload(files) {
      this.uploading = true;
      this.csvErrors = undefined;
      const file = files[0];
      document.getElementById('csv-upload-form').reset();
      const result = await this.requests.importUserCSV(file);
      this.uploading = false;
      if (!result) {
        this.showAlert({ message: undefined, type: 'error' });
      } else if (result.isError) {
        this.errorMessages = result.data;
        this.csvErrors = result.data.errors;
      } else {
        this.showAlert({ message: successCsvUpload, type: 'success' });
      }
    },
    async loadUsers() {
      this.loading = true;
      const result = await this.requests.getUsers(
        this.castPagination, this.search, this.searchOwnerId);
      if (result && 'data' in result && 'total' in result) {
        this.users = result.data;
        this.totalItems = result.total;
      }
      this.loading = false;
    },
    async loadAllAdminUsers() {
      const result = await this.requests.getAllAdminUsers();
      if (result && 'data' in result) {
        this.owners = [{
          id: 'all',
          name: '全て',
        }].concat(result.data);
      }
    },
    showContacts(item) {
      const { sites } = item;
      if (!sites || sites.length <= 0 || !sites[0] || !sites[0].id) {
        this.showAlert({ message: noSite, type: 'error' });
        return;
      }
      const sid = sites[0].id;
      this.$router.push({ name: 'AdminContacts', params: { sid } });
    },
    async showDetail(item) {
      if (item) {
        this.editedId = item.id;
        this.editedItem = await this.requests.getUserDetail(item.id);
      } else {
        this.editedId = undefined;
        this.editedItem = await this.requests.getUserDetail();
      }
      this.errorMessages = [];
      this.detail = true;
    },
    async simulateUser(item) {
      const result = await this.requests.simulateUser(item.id);
      if (!result) {
        this.showAlert({ message: undefined, type: 'error' });
        return;
      }
      const siteResult = await this.setSite();
      if (!siteResult) {
        window.console.log('サイト未作成');
      }
      this.$router.push('../website/basic');
    },
    async deleteCsvErrors() {
      this.csvErrors = undefined;
    },
  },
  async created() {
    await this.loadUsers();
    await this.loadAllAdminUsers();
    this.initiated = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Users.vue